// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3UPIR","savePackageButton":"ClientWallet_savePackageButton__Xc2D6"};